import {
  AboutResourcesBS,
  AboutResourcesDA,
  AboutResourcesDE,
  AboutResourcesEN,
} from "../pages/AboutAida/resources";
import {
  BooksResourcesBS,
  BooksResourcesDA,
  BooksResourcesDE,
  BooksResourcesEN,
} from "../pages/Books/resources";
import {
  ContactResourcesBS,
  ContactResourcesDA,
  ContactResourcesDE,
  ContactResourcesEN,
} from "../pages/Contact/resources";
import {
  FooterResourcesBS,
  FooterResourcesDA,
  FooterResourcesDE,
  FooterResourcesEN,
} from "../layouts/Footer.resources";
import {
  HomeResourcesBS,
  HomeResourcesDA,
  HomeResourcesDE,
  HomeResourcesEN,
} from "../pages/Frontpage/resources";
import {
  ImpressumResourcesBS,
  ImpressumResourcesDA,
  ImpressumResourcesDE,
  ImpressumResourcesEN,
} from "../pages/Impressum/resources";
import {
  LecturesResourcesBS,
  LecturesResourcesDA,
  LecturesResourcesDE,
  LecturesResourcesEN,
} from "../pages/Lectures/resources";
import {
  MediaResourcesBS,
  MediaResourcesDA,
  MediaResourcesDE,
  MediaResourcesEN,
} from "../pages/Media/resources";
import {
  MenuResourcesBS,
  MenuResourcesDA,
  MenuResourcesDE,
  MenuResourcesEN,
} from "../layouts/Menu.resources";
import {
  OnlineCoursesResourcesBS,
  OnlineCoursesResourcesDA,
  OnlineCoursesResourcesDE,
  OnlineCoursesResourcesEN,
} from "../pages/OnlineCourses/resources";
import {
  PodcastResourcesBS,
  PodcastResourcesDA,
  PodcastResourcesDE,
  PodcastResourcesEN,
} from "../pages/Podcast/resources";

import LanguageDetector from "i18next-browser-languagedetector";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  da: {
    translation: {
      menu: MenuResourcesDA,
      footer: FooterResourcesDA,
      home: HomeResourcesDA,
      about: AboutResourcesDA,
      books: BooksResourcesDA,
      contact: ContactResourcesDA,
      lectures: LecturesResourcesDA,
      media: MediaResourcesDA,
      onlinecourses: OnlineCoursesResourcesDA,
      podcast: PodcastResourcesDA,
      impressum: ImpressumResourcesDA,
    },
  },
  en: {
    translation: {
      menu: MenuResourcesEN,
      footer: FooterResourcesEN,
      home: HomeResourcesEN,
      about: AboutResourcesEN,
      books: BooksResourcesEN,
      contact: ContactResourcesEN,
      lectures: LecturesResourcesEN,
      media: MediaResourcesEN,
      onlinecourses: OnlineCoursesResourcesEN,
      podcast: PodcastResourcesEN,
      impressum: ImpressumResourcesEN,
    },
  },
  de: {
    translation: {
      menu: MenuResourcesDE,
      footer: FooterResourcesDE,
      home: HomeResourcesDE,
      about: AboutResourcesDE,
      books: BooksResourcesDE,
      contact: ContactResourcesDE,
      lectures: LecturesResourcesDE,
      media: MediaResourcesDE,
      onlinecourses: OnlineCoursesResourcesDE,
      podcast: PodcastResourcesDE,
      impressum: ImpressumResourcesDE,
    },
  },
  bs: {
    translation: {
      menu: MenuResourcesBS,
      footer: FooterResourcesBS,
      home: HomeResourcesBS,
      about: AboutResourcesBS,
      books: BooksResourcesBS,
      contact: ContactResourcesBS,
      lectures: LecturesResourcesBS,
      media: MediaResourcesBS,
      onlinecourses: OnlineCoursesResourcesBS,
      podcast: PodcastResourcesBS,
      impressum: ImpressumResourcesBS,
    },
  },
};

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: "da",
    load: "languageOnly",
    supportedLngs: ["da", "en", "de", "bs"],
    cleanCode: true,
    nonExplicitSupportedLngs: true,
    debug: false,
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "language",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export default i18next;
